import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-0 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full col-start-2 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
const _hoisted_5 = { class: "dark:text-gray-400" }
const _hoisted_6 = { class: "pt-16 sm:pt-16 md:pt-5 lg:pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-full" }
const _hoisted_7 = { class: "w-full py-3 md:py-0 sm:pb-10 lg:py-6 max-w-2xl my-2" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_10 = { class: "w-full lg:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_11 = {
  class: "list-disc list-inside font-bold",
  style: {"list-style-type":"disc","list-style-position":"inside"}
}
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "font-medium" }
const _hoisted_14 = { class: "font-medium" }
const _hoisted_15 = {
  class: "list-disc list-inside font-bold",
  style: {"list-style-type":"disc","list-style-position":"inside"}
}
const _hoisted_16 = { class: "font-medium" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_21 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_22 = { class: "w-full lg:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_23 = {
  class: "list-disc list-inside font-bold",
  style: {"list-style-type":"disc","list-style-position":"inside"}
}
const _hoisted_24 = { class: "font-medium" }
const _hoisted_25 = { class: "font-medium" }
const _hoisted_26 = { class: "font-medium" }
const _hoisted_27 = { class: "font-medium" }
const _hoisted_28 = { class: "font-medium" }
const _hoisted_29 = { class: "font-medium" }
const _hoisted_30 = { class: "font-medium" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_33 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_34 = { class: "w-full lg:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_35 = { class: "list-disc list-inside font-bold" }
const _hoisted_36 = { class: "font-medium" }
const _hoisted_37 = { class: "font-medium" }
const _hoisted_38 = { class: "font-medium" }
const _hoisted_39 = { class: "font-medium" }
const _hoisted_40 = { class: "font-medium" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_43 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_44 = { class: "w-full md:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_45 = { class: "list-disc list-inside font-bold" }
const _hoisted_46 = { class: "font-medium" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "list-disc list-inside font-bold" }
const _hoisted_49 = { class: "font-medium" }
const _hoisted_50 = { class: "font-medium" }
const _hoisted_51 = { class: "font-medium" }
const _hoisted_52 = { class: "font-medium" }
const _hoisted_53 = { class: "font-medium" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_56 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_57 = { class: "w-full lg:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_58 = { class: "list-disc list-inside font-bold" }
const _hoisted_59 = { class: "font-medium" }
const _hoisted_60 = { class: "font-medium" }
const _hoisted_61 = { class: "font-medium" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_64 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full" }
const _hoisted_65 = { class: "w-full lg:w-2/5 py-3 sm:py-0 sm:pb-10 lg:py-6 " }
const _hoisted_66 = { class: "list-disc list-inside font-bold" }
const _hoisted_67 = { class: "font-medium" }
const _hoisted_68 = { class: "font-medium" }
const _hoisted_69 = { class: "font-medium" }
const _hoisted_70 = { class: "font-medium" }
const _hoisted_71 = { class: "font-medium" }
const _hoisted_72 = { class: "font-medium" }
const _hoisted_73 = { class: "font-medium" }
const _hoisted_74 = { class: "font-medium" }
const _hoisted_75 = { class: "font-medium" }
const _hoisted_76 = { class: "font-medium" }
const _hoisted_77 = { class: "font-medium" }
const _hoisted_78 = { class: "font-medium" }
const _hoisted_79 = { class: "font-medium" }
const _hoisted_80 = { class: "font-medium" }
const _hoisted_81 = { class: "font-medium" }
const _hoisted_82 = { class: "font-medium" }
const _hoisted_83 = { class: "font-medium" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "w-full lg:w-3/5 py-3 lg:px-6 sm:py-0 sm:pb-10 lg:py-6 " }, [
  /*#__PURE__*/_createVNode("video", {
    class: "rounded-3xl",
    controls: "",
    src: "/img/test/dogo.mp4"
  })
], -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("contentGuide.ContentGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.ContentGuideDetail1")) + _toDisplayString(_ctx.$t("contentGuide.ContentGuideDetail2")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.StyleGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.StyleGuideDetail")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.StyleGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_11, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList1Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList1Item3")), 1)
                  ])
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.StyleGuideListTitle2")), 1),
                _createVNode("ol", _hoisted_15, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList2Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList2Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("contentGuide.StyleGuideList2Item3")), 1)
                  ])
                ])
              ]),
              _hoisted_19,
              _hoisted_20
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.WordingGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.WordingGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_23, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item3")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item4")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item5")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item6")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("contentGuide.WordingGuideList1Item7")), 1)
                  ])
                ])
              ]),
              _hoisted_31,
              _hoisted_32
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.FileGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.FileGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_35, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("contentGuide.FileGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("contentGuide.FileGuideList1Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("contentGuide.FileGuideList1Item3")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("contentGuide.FileGuideList1Item4")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("contentGuide.FileGuideList1Item5")), 1)
                  ])
                ])
              ]),
              _hoisted_41,
              _hoisted_42
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.LinkGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.LinkGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_45, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList1Item2")), 1)
                  ])
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.LinkGuideListTitle2")), 1),
                _createVNode("ol", _hoisted_48, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList2Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList2Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList2Item3")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList2Item4")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("contentGuide.LinkGuideList2Item5")), 1)
                  ])
                ])
              ]),
              _hoisted_54,
              _hoisted_55
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.CopyrightGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.CopyrightGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_58, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("contentGuide.CopyrightGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("contentGuide.CopyrightGuideList1Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("contentGuide.CopyrightGuideList1Item3")), 1)
                  ])
                ])
              ]),
              _hoisted_62,
              _hoisted_63
            ]),
            _createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, [
                _createVNode("h1", null, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideTitle")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideDetail")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideListTitle1")), 1),
                _createVNode("ol", _hoisted_66, [
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_67, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item1")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item2")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_69, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item3")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_70, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item4")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item5")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item6")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_73, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item7")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item8")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_75, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item9")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item10")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_77, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item11")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item12")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_79, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item13")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item14")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_81, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item15")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_82, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item16")), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_83, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideList1Item17")), 1)
                  ])
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t("contentGuide.NotAllowedGuideDetail2")), 1)
              ]),
              _hoisted_84,
              _hoisted_85
            ])
          ])
        ])
      ])
    ])
  ]))
}